import { useLocation } from 'react-router-dom';
import { useMe } from '../../store/queryHooks';
import { useUiStore } from '../../store/ui';
import { YearMenu } from '../YearMenu/YearMenu';
import { MonthMenu } from '../MonthMenu/MonthMenu';
import styles from './Header.module.css';

interface Props {
  onOpenImport: () => void;
  onOpenExport: () => void;
  onOpenCopyYear: () => void;
}

const TITLES: Record<string, [string, string]> = {
  '/overblik': ['God dag', 'Her er jeres økonomi i denne måned.'],
  '/budget': ['Månedsbudget', 'Budget mod faktisk forbrug, kategori for kategori.'],
  '/indtaegter': ['Indtægter', 'Løn, ydelser og andre indtægter — måned for måned.'],
  '/faste': [
    'Faste udgifter',
    'Bolig, bil, abonnementer, forsikring og opsparing — måned for måned.',
  ],
  '/variable': ['Variable udgifter', 'Dagligvarer, børn og andet der svinger fra måned til måned.'],
  '/maal': ['Opsparing', 'Opret opsparing og følg den måned for måned.'],
  '/konti': ['Konti', 'Saldo på jeres konti — måned for måned.'],
  '/guide': ['Guide', 'Din personlige økonomi-guide, baseret på jeres egne tal.'],
  '/pension': ['Pension', 'Saml pensionsopsparingen i det store billede.'],
  '/gaeld': ['Gæld', 'Overblik over lån og gæld.'],
  '/familier': ['Familier', 'Opret og administrér familier. Hver familie er én bruger.'],
  '/indstillinger': ['Indstillinger', 'Forbindelser, familie og din Gemini-nøgle.'],
};

export function Header({ onOpenImport, onOpenExport, onOpenCopyYear }: Props) {
  const location = useLocation();
  const path = location.pathname;
  const me = useMe();
  const dark = useUiStore((s) => s.dark);
  const toggleDark = useUiStore((s) => s.toggleDark);
  const [rawTitle, sub] = TITLES[path] ?? TITLES['/overblik']!;
  const title = path === '/overblik' && me.data?.name ? `${rawTitle}, ${me.data.name}` : rawTitle;
  const isBudget = path === '/budget';
  const hideActions = ['/indstillinger', '/familier', '/guide'].includes(path);
  return (
    <header className={styles.header} data-print="hide">
      <div>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.sub}>{sub}</p>
      </div>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.iconBtn}
          onClick={toggleDark}
          title={dark ? 'Lyst tema' : 'Mørkt tema'}
          aria-label={dark ? 'Lyst tema' : 'Mørkt tema'}
        >
          {dark ? '☀' : '☾'}
        </button>
        {!hideActions && (
          <>
            <YearMenu onOpenCopy={onOpenCopyYear} />
            {isBudget && <MonthMenu />}
            <button className={styles.iconBtn} onClick={onOpenExport}>
              <span>↓</span> Eksportér
            </button>
            <button className={`${styles.iconBtn} ${styles.primary}`} onClick={onOpenImport}>
              <span>↑</span> Importér
            </button>
          </>
        )}
      </div>
    </header>
  );
}
